import React from "react";

export default function NoDataFound({ message }) {
  return <div className="flex justify-center w-full text-xl">{message}</div>;
}
